<template>
  <div>
    <div
      v-show="showFooter"
      class="footer"
      :style="{
        'grid-template-columns': 'repeat(' + gridNum + ', 1fr)',
        'grid-row-gap': ' 3vw',
      }"
    >
      <div
        class="item"
        v-for="(item, index) in menu"
        :key="index"
        @click="toPage(item.url), changeIcon(item.url)"
      >
        <!-- 点亮 -->
        <img :src="item.colorIcon" v-if="iconValue == item.url" alt="" />
        <!-- 灰色 -->
        <img :src="item.grayIcon" v-else alt="" />

        <span>{{ item.name }}</span>
      </div>
    </div>
  </div>
</template>

<script>
// 图标地址：https://www.iconfont.cn/collections/detail?spm=a313x.user_detail.i1.dc64b3430.1a503a81BpR6Ii&cid=41768
import { Toast, Dialog } from "vant";
import { getDepNameByDomain } from "@/utils/index";
import { getToken } from "@/utils/auth.js";
import { xcDepConfig } from "@/api/depConfig.js";
import { getCurrentChannelInfo } from "@/api/login.js";
export default {
  computed: {},
  created() {
    this.getDepConfig();
  },
  data() {
    return {
      showFooter: true,
      // 平台配置
      depConfig: {},
      // 平台名称
      depName: "",
      // 一栏显示几个功能
      gridNum: 5,
      // 当前点亮的图标
      iconValue: "",
      // 渠道信息
      channelInfo: {},
      // 底部菜单 用于展示
      menu: [],
      // 默认菜单数据
      defaultMenu: [
        {
          name: "产品中心",
          colorIcon:
            "https://static.xchengtech.cn/62d49e58479e477882605eba4e74e304.png",
          grayIcon:
            "https://static.xchengtech.cn/51cb8f13f89a4a7c82866c00b315c72b.png",
          url: "index",
        },
        {
          name: "查询中心",
          colorIcon:
            "https://static.xchengtech.cn/01e077a05d984071817195525a156a15.png",
          grayIcon:
            "https://static.xchengtech.cn/403b8118188e4d22b35769d5f1a62aa4.png",
          url: "applyCenter",
        },
        {
          name: "我的客户",
          colorIcon:
            "https://static.xchengtech.cn/202d7d8eb04c4bd5a824937e98951274.png",
          grayIcon:
            "https://static.xchengtech.cn/f5a78eec5c1b4bbd928802c648bc2132.png",
          url: "myCustomer",
        },
        {
          name: "拓客中心",
          colorIcon:
            "https://static.xchengtech.cn/617c37ae8d47411f97c89a92f6e4d5b0.png",
          grayIcon:
            "https://static.xchengtech.cn/e1629c6eb0564415882f83f3d306ff5b.png",
          url: "customerCenter",
        },
        {
          name: "个人中心",
          colorIcon:
            "https://static.xchengtech.cn/460fc19c8c1b4c218dfc5990b4cbc1c2.png",
          grayIcon:
            "https://static.xchengtech.cn/237d89f0b7214c50b1967c290c29969d.png",
          url: "userCenter",
        },
      ],
    };
  },
  watch: {
    $route: {
      handler(val, oldval) {
        this.toParseUrl();
      },
      // 深度观察监听
      deep: true,
    },
  },
  mounted() {
    // 解析当前地址，来决定底部导航栏显示哪个图标
    this.toParseUrl();
  },
  methods: {
    toCustomerPopup() {
      if (this.depConfig.customerServerEwm) {
        this.customerPopup = !this.customerPopup;
      } else {
        Toast.fail("暂无客服");
      }
    },
    getDepConfig() {
      this.depName = getDepNameByDomain();
      xcDepConfig(this.depName).then((res) => {
        this.depConfig = res;
        // 商协会模式 分配免登录版本
        if (
          this.depConfig.bizType === "ssh" ||
          this.depConfig.bizType === "csqfpt"
        ) {
          // 退役军人服务平台 xrr 单独配置
          if (this.depName === "xrr") {
            this.menu = [
              {
                name: "产品中心",
                colorIcon:
                  "https://static.xchengtech.cn/7d80b28cd3fa4f53b5219a51c91d0cc0.png",
                grayIcon:
                  "https://static.xchengtech.cn/29706f16ac8244fa8f4b80cb1ed649cb.png",
                url: "index",
              },
              {
                name: "智能客服",
                colorIcon:
                  "https://static.xchengtech.cn/bc931aaa88434e138974140ec07e2667.png",
                grayIcon:
                  "https://static.xchengtech.cn/f5a78eec5c1b4bbd928802c648bc2132.png",
                url: "robotForXrr",
              },

              {
                name: "融资申请",
                colorIcon:
                  "https://static.xchengtech.cn/7c00456b63de4389809e911c05085057.png",
                grayIcon:
                  "https://static.xchengtech.cn/68731536672043fa8faba0ebd4435529.png",
                url: "leadInfoForXrr",
              },
              {
                name: "我的",
                colorIcon:
                  "https://static.xchengtech.cn/0a2bc9ccd7b1488fbaacc162eb6d8a4d.png",
                grayIcon:
                  "https://static.xchengtech.cn/fe336a776a434a9d8c19baae1260aa78.png",
                url: "productCollectionForXrr",
              },
            ];
          } else {
            this.menu = [
              {
                name: "产品中心",
                colorIcon:
                  "https://static.xchengtech.cn/e049f1d92bb845da8d26eac67e1c7ab3.png",
                grayIcon:
                  "https://static.xchengtech.cn/29706f16ac8244fa8f4b80cb1ed649cb.png",
                url: "index",
              },
              {
                name: "智能客服",
                colorIcon:
                  "https://static.xchengtech.cn/202d7d8eb04c4bd5a824937e98951274.png",
                grayIcon:
                  "https://static.xchengtech.cn/f5a78eec5c1b4bbd928802c648bc2132.png",
                url: "robot",
              },

              {
                name: "融资申请",
                colorIcon:
                  "https://static.xchengtech.cn/8fb4f1274ef0495daee5793564240c2e.png",
                grayIcon:
                  "https://static.xchengtech.cn/68731536672043fa8faba0ebd4435529.png",
                url: "leadInfoNL",
              },
              {
                name: "我的",
                colorIcon:
                  "https://static.xchengtech.cn/593f9e9b4e354d5b8eb88be47eb53b2a.png",
                grayIcon:
                  "https://static.xchengtech.cn/fe336a776a434a9d8c19baae1260aa78.png",
                url: "productCollection",
              },
            ];
          }

          this.gridNum = 4;
        }
        // 广州好邻
        else if (this.depConfig.bizType === "gzhlkj") {
          this.menu = [
            {
              name: "产品中心",
              colorIcon:
                "https://static.xchengtech.cn/e049f1d92bb845da8d26eac67e1c7ab3.png",
              grayIcon:
                "https://static.xchengtech.cn/29706f16ac8244fa8f4b80cb1ed649cb.png",
              url: "index",
            },
            {
              name: "智能客服",
              colorIcon:
                "https://static.xchengtech.cn/202d7d8eb04c4bd5a824937e98951274.png",
              grayIcon:
                "https://static.xchengtech.cn/f5a78eec5c1b4bbd928802c648bc2132.png",
              url: "robot",
            },
            {
              name: "融资申请",
              colorIcon:
                "https://static.xchengtech.cn/8fb4f1274ef0495daee5793564240c2e.png",
              grayIcon:
                "https://static.xchengtech.cn/68731536672043fa8faba0ebd4435529.png",
              url: "leadInfoNL",
            },
          ];
          this.gridNum = 3;
        }
        // 其他平台
        else {
          // 赋值菜单
          this.menu = this.defaultMenu;
          // 判断该租户是否关闭了客户中心功能
          if (!this.depConfig.customerCenterFlag) {
            let index = this.menu.findIndex((item) => {
              return item.name == "我的客户";
            });
            this.menu.splice(index, 1);
            let index1 = this.menu.findIndex((item) => {
              return item.name == "拓客中心";
            });
            this.menu.splice(index1, 1);
            // 如果关闭了客户中心功能，则一行显示三个功能
            this.gridNum = 3;
          } else {
            this.gridNum = 5;
          }
        }
      });
    },
    toPage(name) {
      // 判断是否重复点击
      let routeName = this.$route.path;
      if (routeName == "/" + name) {
        return false;
      }
      switch (name) {
        // 首页
        case "index":
          this.$router.push({ path: "/" });
          break;
        // 融资申请(需要登录)
        case "apply":
          if (getToken()) {
            // 获取渠道用户信息
            getCurrentChannelInfo()
              .then((res) => {
                this.channelInfo = res;
                let domain = "https://apply.xchengtech.cn";
                let url =
                  domain +
                  "/#/info?channelId=" +
                  this.channelInfo.id +
                  "&depName=" +
                  this.channelInfo.depName;
                this.toUrl(url);
              })
              .catch((err) => {
                console.log("err", err);
                Toast.clear();
              });
          } else {
            this.$router.push({
              path: "/login",
            });
          }
          break;
        // 商协会版本 跳转至数据报告项目
        case "companyRep":
          // Toast.loading({
          //   duration: 0, // 持续展示 toast
          //   forbidClick: true,
          //   message: "加载中",
          // });
          // 判断当前平台是哪个商协会，跳转至对应渠道的码
          // 总协会
          if (this.depConfig.depName === "jf") {
            window.location.href =
              // "https://wx.xchengtech.cn/saas/getOpenId?destination=code&depName=xc&url=https%3A%2F%2Fxccompanyrepo.xchengtech.cn%2F%23%2FreportList%3FpriceCode%3D6bcaf21529664940a722681e76f714fa%26channelId%3D4f9cb452fcdb4906bbe037e4f709898b";
              "https://xccompanyrepo.xchengtech.cn/#/reportList?priceCode=6bcaf21529664940a722681e76f714fa&channelId=4f9cb452fcdb4906bbe037e4f709898b";
          }
          // 代理记账协会
          if (this.depConfig.depName === "dljzxh") {
            window.location.href =
              // "https://wx.xchengtech.cn/saas/getOpenId?destination=code&depName=xc&url=https%3A%2F%2Fxccompanyrepo.xchengtech.cn%2F%23%2FreportList%3FpriceCode%3Da69e50343f02471abaf11573702ee0b2%26channelId%3D95a5bd9d04f5475680967f400a23918d";
              "https://xccompanyrepo.xchengtech.cn/#/reportList?priceCode=a69e50343f02471abaf11573702ee0b2&channelId=95a5bd9d04f5475680967f400a23918d";
          }
          // 湖南省商业综合体服务协会
          if (this.depConfig.depName === "hnssyzhtfwxh") {
            window.location.href =
              // "https://wx.xchengtech.cn/saas/getOpenId?destination=code&depName=xc&url=https%3A%2F%2Fxccompanyrepo.xchengtech.cn%2F%23%2FreportList%3FpriceCode%3Da658ef3c792c4e8086a6f994d83b853b%26channelId%3D0a6ce9ce37134c96b0fe2a4157975229";
              "https://xccompanyrepo.xchengtech.cn/#/reportList?priceCode=a658ef3c792c4e8086a6f994d83b853b&channelId=0a6ce9ce37134c96b0fe2a4157975229";
          }
          // 湖南退役军人服务平台
          if (this.depConfig.depName === "hntyjrpt") {
            window.location.href =
              // "https://wx.xchengtech.cn/saas/getOpenId?destination=code&depName=xc&url=https%3A%2F%2Fxccompanyrepo.xchengtech.cn%2F%23%2FreportList%3FpriceCode%3Da8d58c7d6d0f4d9c82a8d2269d26dd3a%26channelId%3Dc01b0b59efd348368b28bba5aafdd684";
              "https://xccompanyrepo.xchengtech.cn/#/reportList?priceCode=a8d58c7d6d0f4d9c82a8d2269d26dd3a&channelId=c01b0b59efd348368b28bba5aafdd684";
          }
          // 穗空间
          if (this.depConfig.depName === "skj") {
            window.location.href =
              // "https://wx.xchengtech.cn/saas/getOpenId?destination=code&depName=xc&url=https%3A%2F%2Fxccompanyrepo.xchengtech.cn%2F%23%2FreportList%3FpriceCode%3D1c53bdef1fcf46a1852654c4297661ea%26channelId%3D74d16ae2bcb04dd48a7e0945ce976211";
              "https://xccompanyrepo.xchengtech.cn/#/reportList?priceCode=1c53bdef1fcf46a1852654c4297661ea&channelId=74d16ae2bcb04dd48a7e0945ce976211";
          }
          break;
        default:
          this.$router.push({ path: "/" + name });
          break;
      }
    },
    changeIcon(name) {
      if (name != "customer" && name != "apply") this.iconValue = name;
    },
    toUrl(url) {
      window.location.href = url;
    },
    toParseUrl() {
      let url = window.location.href;
      // 查询中心
      if (url.indexOf("applyCenter") > -1) {
        this.iconValue = "applyCenter";
      }
      // 我的客户
      else if (url.indexOf("myCustomer") > -1) {
        this.iconValue = "myCustomer";
      }
      // 拓客中心
      else if (url.indexOf("customerCenter") > -1) {
        this.iconValue = "customerCenter";
      }
      // 个人中心
      else if (url.indexOf("userCenter") > -1) {
        this.iconValue = "userCenter";
      }
      // 智能客服
      else if (url.indexOf("robot") > -1) {
        // 退役军人服务平台 xrr
        if (url.indexOf("robotForXrr") > -1) {
          this.iconValue = "robotForXrr";
        } else {
          this.iconValue = "robot";
        }
      }
      // 融资申请
      else if (url.indexOf("leadInfo") > -1) {
        // 退役军人服务平台 xrr
        if (url.indexOf("leadInfoForXrr") > -1) {
          this.iconValue = "leadInfoForXrr";
        } else {
          this.iconValue = "leadInfo";
        }
      }

      // 团队管理
      else if (url.indexOf("lowerLevelChannels") > -1) {
        this.iconValue = "lowerLevelChannels";
      }
      // 商协会版本 八大产品合集： 我的
      else if (url.indexOf("productCollection") > -1) {
        // 退役军人服务平台 xrr
        if (url.indexOf("productCollectionForXrr") > -1) {
          this.iconValue = "productCollectionForXrr";
        } else {
          this.iconValue = "productCollection";
        }
      }
      // 默认首页
      else {
        this.iconValue = "index";
      }
    },
  },
};
</script>

<style scoped src="./footer.css"></style>



// WEBPACK FOOTER //
// src/components/footer/footer.vue